export function getFlagEmoji(countryCode: string) {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map((char) => 127397 + char.charCodeAt(0));

  return String.fromCodePoint(...codePoints);
}

export function getFlagEmojiFromEndPoint(flag: string) {
  const codePoints = flag
    .split(';')
    .filter((x) => x !== '')
    .map((char) => Number(char.replaceAll('&#', '')));

  return String.fromCodePoint(...codePoints);
}
